const ALL_COMPILERS = [{ name: 'Loading...', std: ['Loading...'] }];

export default {
    allCompilers: ALL_COMPILERS,
    latestCompiler: 'Loading...',
    protocolVersion: 5
};
